import { CreateAdmin } from "../../../users/userTypes"
import { UserType } from "../../../login/loginTypes"
import { Page } from "../../../../shared/components/pageHeader/PageHeaderApi"

export function getPageTitle({ type }: Pick<CreateAdmin, "type">) {
    switch (type) {
        case UserType.OFFICE_MANAGER:
            return Page.TENANT_CREATE_OFFICE_MANAGER

        case UserType.MERCHANT:
            //TODO: handle the case when a supplier creates a merchant
            return Page.MERCHANT_CREATE_ADMIN

        case UserType.COMPANY:
            return Page.COMPANY_CREATE_ADMIN

        case UserType.SUPPLIER:
            return Page.SUPPLIER_CREATE_ADMIN

        case UserType.SUPPORT:
            return Page.SUPPORT_CREATE_ADMIN

        case UserType.SERVICE_CENTER:
            return Page.SERVICE_CENTER_ADMIN_ACCOUNT_CREATE_ADMINS_ROUTE
    }
}
